import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { complianceApi } from '~/shared/services/api';

export const PUT_EMPLOYEE_ROLE_QUERY = 'putEmployeeRole';

export type PutEmployeeLanguageRequest = {
  employeeId: string;
  preferredLanguage: string;
};

export type PutEmployeeLanguageResponse = {
  success: boolean;
  message?: string;
};

async function putEmployeeLanguage(data: PutEmployeeLanguageRequest) {
  return complianceApi.put<PutEmployeeLanguageResponse>(
    `/employees/${data.employeeId}/language`,
    {
      preferredLanguage: data.preferredLanguage,
    }
  );
}

type UsePutEmployeeLanguageOptions = {
  onSuccess?: (data: AxiosResponse) => void;
  onError?: (error: Error) => void;
};

export function usePutEmployeeLanguage({
  onSuccess,
  onError,
}: UsePutEmployeeLanguageOptions = {}) {
  return useMutation({
    mutationFn: (data: PutEmployeeLanguageRequest) => putEmployeeLanguage(data),
    onSuccess,
    onError,
  });
}
